// removed by extract-text-webpack-plugin
module.exports = {"button":"_1MgdHpBkrlOgXMjuvYev0-","loadingWrapper":"_1__OoH_ULqu9i-_11PKGoX","disabled":"_1-HZzRvPIFxGFJ2Ri3ZszO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/style.scss
// module id = 375
// module chunks = 1